export default function warn() {
  var _console;

  typeof window !== 'undefined' && console && console.warn && (_console = console).warn.apply(_console, arguments);
}


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/lib/warn.js